import { render, staticRenderFns } from "./storage.vue?vue&type=template&id=42ddff78&scoped=true&"
import script from "./storage.vue?vue&type=script&lang=js&"
export * from "./storage.vue?vue&type=script&lang=js&"
import style0 from "./storage.vue?vue&type=style&index=0&id=42ddff78&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42ddff78",
  null
  
)

export default component.exports